import { render, staticRenderFns } from "./ProjectFiltering.vue?vue&type=template&id=36ea7234&scoped=true"
import script from "./ProjectFiltering.vue?vue&type=script&lang=js"
export * from "./ProjectFiltering.vue?vue&type=script&lang=js"
import style0 from "./ProjectFiltering.vue?vue&type=style&index=0&id=36ea7234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea7234",
  null
  
)

export default component.exports